<template>
  <div id="app" class="w-full h-full flex flex-col">
    <div
      v-if="isLoading"
      class="w-full h-full flex flex-row items-center justify-center"
    >
      <BaseLoader size="3xl" />
    </div>
    <component v-else :is="layout">
      <router-view />
    </component>

    <NotificationPopup v-bind="alert" />
  </div>
</template>

<script>
  import {mapState} from 'vuex';

  import MainLayout from '@/layouts/main';
  import BaseLoader from '@/components/global/base-loader';
  import NotificationPopup from '@/components/global/popups/NotificationPopup';

  export default {
    name: 'App',

    components: {
      BaseLoader,
      NotificationPopup,
    },

    data() {
      return {
        defaultLayout: MainLayout,
      };
    },

    computed: {
      ...mapState('Notification', ['alert']),

      layout() {
        return this.$route.meta.layout || this.defaultLayout;
      },

      isLoading() {
        return this.$store.state.Auth.loading;
      },
    },
  };
</script>

<style lang="scss">
  html,
  body {
    height: 100%;
  }
</style>
